import axios from '../utils/axios';

export default function fetchSeekerEmailNotifSettings(adminId, params) {
        return (
            axios.get('/admin/' + adminId + '/seeker-notification-settings', { params })
        )   
}
